define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for CNC integrations.
     *
     * @class NativeContentIntegration
     */
    return IntegrationModel.extend("NativeContentIntegration", {}, {
        type: "NativeContentIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/NativeContentIntegrationModel.js